import { Box, BoxProps } from 'reflexbox';
import styled from 'styled-components';

import { tokens } from '../theme/tokens';
import { Skeleton } from './Skeleton';

const Container = styled(Box)<{ squared?: boolean }>`
	background: ${tokens.border.subtle};
	border-radius: ${(props) => (props.squared ? '3px' : '0 10px')};
`;

const Fill = styled(Box)<{ completed?: boolean; squared?: boolean }>`
	background: ${(props) =>
		props.completed ? props.theme.colors.green : props.theme.colors.primary};
	border-radius: ${(props) => (props.squared ? '3px' : '0 10px')};
`;

export const Progress = Skeleton(
	function Progress(
		props: BoxProps & {
			value: number;
			squared?: boolean;
		},
	) {
		return (
			<Container
				{...props}
				width={props.width ?? '100px'}
				height={props.height ?? '6px'}
				squared={props.squared}
			>
				<Fill
					height={props.height ?? '6px'}
					width={`${(props.value * 100).toFixed(0)}%`}
					completed={props.value.toFixed(2) === '1.00'}
					squared={props.squared}
				/>
			</Container>
		);
	},
	styled(Skeleton.Box)<{ width?: string; height?: string; squared?: boolean }>`
		width: ${(props) => props.width ?? '100px'};
		height: ${(props) => props.height ?? '6px'};
		border-radius: ${(props) => (props.squared ? '3px' : '0 2px')};
	`,
);
